import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal } from "../../../../util";
import { Link } from "react-router-dom";
import RefundEventSettingsForm from "./refundEventSettingsForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

export default function RefundEventSettingsPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getRefundEvents = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getRefundEvents(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if(pageSize) getRefundEvents();
  }, [getRefundEvents]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this event?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteRefundEventById(id);
        toast.dark("The event is deleted.");
        await getRefundEvents();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const saveOrdering = async () => {
    try {
      await apiHelper.hkiff.orderRefundEvents(rows.map((e) => e.id));
      toast.dark("Your changes is saved.");
      await getRefundEvents();
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Event Name (English)",
        accessor: "localizations.en.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.en.name}
            </Link>
          );
        },
      },
      {
        Header: "Event Name (Traditional Chinese)",
        accessor: "localizations.tc.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.tc.name}
            </Link>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Refund &gt; Event Settings
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <RefundEventSettingsForm
            description="Add New Event"
            submitBtnTxt="Add New Event"
            gridSize={4}
            upperBtnGroupSize="75%"
            fetchData={getRefundEvents}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getRefundEvents}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.hkiff.deleteRefundEventById(id)))}
            subject="event"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
}
